module.exports = __webpack_public_path__ + "img/wolf-post.de55868d.png";